<template>
  <generic-modal
    size
    :title="$t('business object')"
    icon="boxes"
    image="/images/icons/object.png"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <div class="ui form" ref="form">
        <div class="field">
          <label for>{{ $t("name") }}</label>
          <input type="text" name="name" v-model="name" />
        </div>
        <div class="field">
          <label for>{{ $t("description") }}</label>
          <textarea
            name="description"
            rows="2"
            v-model="description"
          ></textarea>
        </div>
        <div class="field">
          <label for>{{ $t("structure") }}</label>
          <editor
            @init="init_code"
            v-model="structure"
            lang="json"
            theme="monokai"
          ></editor>
          <!-- <textarea name="structure" rows="2" v-model="structure" id="structure_code"></textarea> -->
        </div>
        <div class="ui error message"></div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import GenericModal from "@/components/GenericModal";
import Editor from "vue2-ace-editor";
import { v4 as uuid } from "uuid";

export default {
  components: {
    "generic-modal": GenericModal,
    editor: Editor
  },
  computed: {},
  props: { business_object: Object },
  data() {
    return {
      description: "",
      name: "",
      structure: ""
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let isValid = window.jQuery(vm.$refs.form).form("validate form");

        if (!isValid) reject();
        else {
          let process = {
            uuid: vm.$props.business_object.uuid || uuid(),
            name: vm.name,
            description: vm.description,
            structure: vm.structure
          };
          vm.$emit("succedded", process);
          resolve();
        }
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    init_code() {
      require("brace/mode/json");
      require("brace/theme/monokai");
    }
  },
  mounted() {
    let vm = this;
    window.jQuery(vm.$refs.form).form({
      fields: {
        name: ["empty"],
        structure: ["empty"]
      }
    });

    let bo = vm.$props.business_object;
    if (bo.uuid) {
      vm.name = bo.name;
      vm.description = bo.description;
      vm.structure = bo.structure;
    }
  },
  watch: {},
  updated: function() {
    this.$nextTick(function() {});
  }
};
</script>
